import React from 'react';
import { loginApi } from '../../api/loginApi.js';
import { useNavigate } from 'react-router-dom';
import './navBar.css'; // Import the CSS file

function NavBar() {
    const navigate = useNavigate();

    const handleHomeClick = () => {
        navigate('/home');
    }

    const handleItemClick = () => {
        navigate('/items');
    }

    const handleHealthClick = () => {
        navigate('/health');
    }

    const handleConsumeClick = () => {
        navigate('/consume');
    }

    const handleOtherClick = () => {
        navigate('/graph');
    }

    const handleLogout = async () => {
        loginApi.logout();
        navigate('/login');
    };

    return (
        <nav className="navbar">
            <button className="nav-button" onClick={handleHomeClick}>Home</button>
            <button className="nav-button" onClick={handleItemClick}>Items</button>
            <button className="nav-button" onClick={handleConsumeClick}>Consume</button>
            <button className="nav-button" onClick={handleHealthClick}>Health</button>
            <button className="nav-button" onClick={handleOtherClick}>Graph</button>
            <button className="nav-button" onClick={handleLogout}>Logout</button>
        </nav>
    )
}

export { NavBar };
